import { useState } from "react";
import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import {
  archiveConversationNodeSchema,
  archiveConversationTemplate,
} from "../../models/endNode";
import { Button } from "V2.0/common/button";

function ArchiveConversationNode(props) {
  const { node, setNodes, closePanel, projectId, notifyChange, options } =
    props;
  const [state, setState] = useState({
    name: node?.data?.settings?.name || "",
    description: node?.data?.settings?.description || "",
    endNodeType: node?.data?.settings?.endNodeType,
    archiveReason: node?.data?.settings?.archiveReason,
    completionStatus: node?.data?.settings?.completionStatus
  });

  const { data, error, validate, handleChange, setError } = useForm(
    state,
    archiveConversationNodeSchema
  );

  function handleSave() {
    const errors = validate(data, archiveConversationNodeSchema);

    if (errors) {
      setError(errors);
      return;
    }

    setNodes((nodes) => {
      const updatedNodes = nodes.map((_node) => {
        if (_node.id === node.id) {
          const { selected, ...rest } = _node;
          return {
            ...rest,
            selected: false,

            data: {
              ...node.data,
              settings: { ...node.data.settings, ...data },
            },
          };
        } else {
          return _node;
        }
      });
      return updatedNodes;
    });
    closePanel();
    notifyChange();
  }

  return (
    <div className="flex flex-col gap-y-4">
      <Form
        data={data}
        handleChange={handleChange}
        error={error}
        template={archiveConversationTemplate}
      />
      <div className="flex self-end">
        <Button onClick={handleSave}>save</Button>
      </div>
    </div>
  );
}

export { ArchiveConversationNode };
